// Vendor
import { Component, OnInit } from "@angular/core";
import { Router, NavigationExtras } from "@angular/router";
import { FormGroup } from "@angular/forms";
import { tap } from "rxjs/operators";

// App
import { OrderService } from "../../services/order/order.service";
import { PATH_STEP_5 } from "../../app-routing.constants";

@Component({
    selector: "ig-step4",
    templateUrl: "./step4.component.html",
    styleUrls: ["./step4.component.scss"],
})
export class Step4Component implements OnInit {
    public isSubmitting: boolean;

    public form = new FormGroup({});

    constructor(
        public router: Router,
        public orderService: OrderService,
    ) { }

    ngOnInit() {
        this.orderService.updateTotal();
        this.form.valueChanges
            .pipe(tap(values => this.orderService.saveValues(values)))
            .subscribe(values => {
                this.orderService.commitOrderToStorage();
                this.orderService.updateTotal();
            });
    }

    public get visibleInvoiceItems() {
        if (this.orderService.quote && this.orderService.quote.items) {
            return this.orderService.quote.items.filter(
                item => item.showOnInvoice,
            );
        }
    }

    public get sendButtonDisabled() {
        return this.form.invalid || this.isSubmitting;
    }

    /**
     * Sends the order to the backend
     *
     * @param $event Click event from clicking on the "next" button
     * @todo show a spinner on the "Next" button while this request is running.
     */
    public sendIt($event?: MouseEvent) {
        if ($event instanceof Event) {
            $event.preventDefault();
        }

        this.isSubmitting = true;

        this.orderService
            .sendIt()
            .subscribe(
                res => this.onSuccessResponse(res),
                res => this.onErrorResponse(res),
            );
    }

    /**
     * Succesful order request response handler
     *
     * Takes the user to the next step with a thank you message.
     *
     * @param res Response of the successful request.
     */
    public onSuccessResponse(res) {
        const commands = [PATH_STEP_5];
        const navigationExtras: NavigationExtras = { replaceUrl: true };

        this.orderService.order.step4Completed = true;
        this.router.navigate(commands, navigationExtras);
    }

    /**
     * Failed order request response handler
     *
     * Shows a plain old alert and dumps the actual error to the console.
     *
     * @param res Error response of the failed order request.
     * @todo Make sure this client-side error is reported to Sentry somehow.
     */
    public onErrorResponse(res) {
        console.error({ res });

        const message = [
            "Er ging iets fout tijdens het verwerken van je order.",
            "Probeer het later nog een keer.",
        ].join(" ");

        window.alert(message);

        this.isSubmitting = false;
    }
}
